<template>
    <header>
        <div class="header-main-block">
            <div class="header-logo-wrapper">
                <router-link to="/">
                    <div class="logo"></div>
                </router-link>
            </div>
            <div class="toggle-menu sandwich" :class="{'active':showNavigation}" @click="$emit('showHideNav')">
                <div class="sw-bottom"></div>
                <div class="sw-footer"></div>
            </div>
        </div>
        <div class="theme-switcher">
            <label class="toggle-switch-label color-mode-switch">
                <span class="switch-label">Light</span>
                <input type="checkbox" :checked="darkTheme" @change="$emit('changeTheme')">
                <span class="switchmark">
                    <span class="switch-check"></span>
                </span>
                <span class="switch-label">Dark</span>
            </label>
        </div>
    </header>

</template>

<script>
    export default {
        name: 'Header',
        props: ['showNavigation','darkTheme']
    };
</script>
<style lang="scss" scoped>
    header {
        border-bottom: 1px solid var(--header-br-color);
        position: fixed;
        width: 100%;
        z-index: 121;
        background: var(--main-bg-color);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .header-main-block{
            display: flex;
            justify-content: space-around;
            align-items: center;
            height: 82px;
            width: 229px;
            border-right: 1px solid var(--header-br-color);
            @media (max-width: 400px) {
                width: 100%;
                justify-content: space-between;
                padding: 0px 14px;
            }
            .header-logo-wrapper{
                .logo{
                    background: var(--logo-link);
                    background-size: cover;
                    width: 106px;
                    height: 49px;
                }
            }
        }
        .theme-switcher{
            padding-right: 24px;
            @media (max-width: 400px) {
                display: none;
            }
            .toggle-switch-label {
                display: inline-flex;
                align-items: center;
                justify-content: space-between;
                width: 130px;
                .switch-label{
                    font-size: 13px;
                    color: var(--font-color);
                    cursor: pointer;
                }
                .switchmark {
                    position: relative;
                    display: inline-block;
                    width: 40px;
                    height: 24px;
                    background: #f2f7ff;
                    box-shadow: inset 0px 0px 10px rgba(44, 103, 255, 0.11);
                    border-radius: 12px;
                    cursor: pointer;
                    flex-shrink: 0;
                    .switch-check {
                        position: absolute;
                        top: 1.8px;
                        left: 2px;
                        display: inline-block;
                        width: 20px;
                        height: 20px;
                        background-color: #fff;
                        border: 1px solid #7c6be9;
                        border-radius: 100%;
                        transition: all .2s ease;
                    }
                }
                input {
                    position: absolute;
                    opacity: 0;
                }
            }
            .toggle-switch-label input:checked~.switchmark 
            {
                background: #1B1F2C;
                box-shadow: inset 0px 0px 10px #242D4B;
                .switch-check {
                    left: 18px;
                    background-color: #313d63;
                    border-color: #8ca5ff;
                }
            }
        }
    }

    // - SANDWICH OPEN MENU BUTTON - //
    .toggle-menu {
        position: relative;
        display: inline-block;
        z-index: 998;
    }

    $w: 28px; // optimal width for this burger animation
    $h: 1px; // optimal height for this burger animation
    $p: 8px; // padding
    $c: #8CA5FF; // burger color

    .sandwich {
        width: $w + $p * 2;
        height: $h * 7 + $p * 2;
        padding: $p;
        cursor: pointer;

        .sw-bottom {
            position: relative;
            width: $w;
            height: $h;
            top: $h * 4;
            background: $c;
            border-radius: 10px;
            transition: all 0.3s;
        }

        .sw-footer {
            position: relative;
            width: $w;
            height: $h;
            top: $h * 10;
            background: $c;
            border-radius: 10px;
            transition: all 0.3s;
        }

        &.active {
            .sw-bottom {
                transform: rotate(45deg) translate(2px, 3px)
            }

            .sw-footer {
                transform: rotate(-45deg) translate(2px, -3px)
            }
        }
    }
</style>